import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import Notify from 'notifyjs';
import { observable, runInAction } from 'mobx';
import { localStorage as storage } from '../misc/storage';
import { stripMarkdown } from '../utils/markdownStripUtil';
var DEFAULT_ICON = require('../assets/img/taxfyle-icon-256px.png');
var DesktopNotificationStore = (_class = /*#__PURE__*/function (_Store) {
  function DesktopNotificationStore() {
    var _this;
    _classCallCheck(this, DesktopNotificationStore);
    _this = _callSuper(this, DesktopNotificationStore, arguments);
    _initializerDefineProperty(_this, "isSupported", _descriptor, _this);
    _initializerDefineProperty(_this, "isEnabled", _descriptor2, _this);
    _this.isSupported = Notify.needsPermission === false || Notify.isSupported();
    _this.rootStore.authStore.onLogin(function () {
      // Restore enabled state.
      var stored = storage.getItem('desktopNotifications');
      var enabled = stored !== 'disabled';
      runInAction(function () {
        _this.isEnabled = enabled;
      });
      _this.setEnabled(enabled);
    });
    return _this;
  }
  _inherits(DesktopNotificationStore, _Store);
  return _createClass(DesktopNotificationStore, [{
    key: "setEnabled",
    value: function () {
      var _setEnabled = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(enabled) {
        var _this2 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!enabled) {
                _context.next = 6;
                break;
              }
              if (!(this.isEnabled && Notify.needsPermission === false)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              _context.next = 5;
              return this._getPermission();
            case 5:
              enabled = _context.sent;
            case 6:
              storage.setItem('desktopNotifications', enabled ? 'enabled' : 'disabled');
              runInAction(function () {
                _this2.isEnabled = enabled;
              });
              if (this.isEnabled) {
                this.show({
                  title: 'Nice!',
                  body: 'Desktop notifications have been enabled. You rock!',
                  tag: 'notifications-enabled'
                });
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setEnabled(_x) {
        return _setEnabled.apply(this, arguments);
      }
      return setEnabled;
    }()
  }, {
    key: "_getPermission",
    value: function _getPermission() {
      var _this3 = this;
      return new Promise(function (resolve) {
        if (!Notify.needsPermission) {
          return resolve(true);
        }
        if (!_this3.isSupported) {
          return resolve(false);
        }
        Notify.requestPermission(function () {
          return resolve(true);
        }, function () {
          return resolve(false);
        });
      });
    }
  }, {
    key: "show",
    value: function show(opts) {
      if (!this.isEnabled) {
        return;
      }
      var notification = new Notify(opts.title, {
        tag: opts.tag,
        body: stripMarkdown(opts.body),
        icon: opts.icon || DEFAULT_ICON,
        badge: DEFAULT_ICON,
        timeout: opts.timeout || 5,
        notifyClick: function notifyClick() {
          window.focus();
          if (opts.onClick) {
            opts.onClick();
          }
          notification.close();
        }
      });
      notification.show();
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "isSupported", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _class);
export { DesktopNotificationStore as default };
//# sourceMappingURL=DesktopNotificationStore.js.map
